import { Box } from "@mui/material";

import SynthesisBudget from "@/modules/play/Components/Synthesis/SynthesisBudget";
import SynthesisCarbon from "@/modules/play/Components/Synthesis/SynthesisCarbon";
import SynthesisProduction from "@/modules/play/Components/Synthesis/SynthesisProduction";
import { ITeam } from "@/utils/types";

export default SynthesisRecapForTeacher;

function SynthesisRecapForTeacher({ team }: { team: ITeam }) {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <SynthesisProduction team={team} />
      <SynthesisBudget team={team} />
      <SynthesisCarbon team={team} />
    </Box>
  );
}
